import { render } from "./OrderPrint.vue?vue&type=template&id=4b8b2c82"
import script from "./OrderPrint.vue?vue&type=script&lang=js"
export * from "./OrderPrint.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/sarayeghalam-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__